export default __webpack_public_path__ + "static/media/PopUpTopArrow.1ff21d7c.svg";